{
  "title": "Grupa RW",
  "subtitle": "Zaloguj się na swoje konto",
  "form": {
    "email": "Email",
    "password": "Hasło",
    "submitIdle": "Zaloguj się",
    "submitting": "Logowanie..."
  },
  "errors": {
    "invalidCredentials": "Niepoprawny email lub hasło",
    "rateLimited": "Zbyt wiele prób logowania. Spróbuj ponownie później.",
    "unknown": "Wystąpił błąd. Spróbuj ponownie."
  }
}
